import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {CallApiComponent} from './routes/call-api/call-api.component';
import {LocalComponent} from './routes/local/local.component';

const routes: Routes = [
  /* Public Area */
  {
    path: '',
    redirectTo: 'local',
    pathMatch: 'full'
  },
  {
    path: 'call-api',
    component: CallApiComponent
  },
  {
    path: 'local',
    component: LocalComponent
  },
  {
    path: '**',
    redirectTo: ''
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {relativeLinkResolution: 'legacy'})],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
